import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import cns from 'classnames';
import { isEmpty } from 'lodash';

class MenuTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: undefined,
            pendingTabId: null,
            location: null
        };
    }

    static propTypes = {
        menuItems: PropTypes.arrayOf(
            PropTypes.shape({
                tabComponent: PropTypes.object,
                name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
                isHidden: PropTypes.bool,
                tabId: PropTypes.string
            })
        ).isRequired,
        className: PropTypes.any,
        initialTab: PropTypes.string,
        menuTabClick: PropTypes.func,
        confirmModalValue: PropTypes.bool,
        resetModalValues: PropTypes.func,
    };

    componentDidMount() {
        const { initialTab } = this.props;
        let firstRenderedTab = this.state.activeTab;
        if (!firstRenderedTab) {
            firstRenderedTab = initialTab;
            this.setState({ activeTab: initialTab });
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.confirmModalValue && this.props.confirmModalValue) {
            this.setState({
                activeTab: this.state.pendingTabId
            }, () => {
                if (this.state.location && this.state.location.pathname && this.state.location.pathname !== this.props.history.location.pathname) {
                    this.props.history.push(this.state.location.pathname);
                    this.props.resetModalValues();
                }
            })
        }
    }

    render() {
        const { menuItems, className = null, menuTabClick = null, confirmModalValue = null } = this.props;
        const { activeTab } = this.state;

        const menu = menuItems.map((item, index) => {
            if (!item.isHidden) {
                const toObject = {};
                toObject.pathname = item.path;
                if (!isEmpty(item.state)) {
                    toObject.state = item.state;
                }
                return (
                    <NavLink
                        key={`tab-${index}`}
                        className={cns('menuSubItem', { activeTab: item.tabId === activeTab })}
                        to={toObject}
                        onClick={(e) => {
                            let changeTab = true;
                            this.setState({pendingTabId: item.tabId, location: toObject})
                            if (menuTabClick && !confirmModalValue) {
                                changeTab = menuTabClick(item.tabId);
                            }
                            if (!changeTab) {
                                e.preventDefault();
                            } else {
                                this.setState({ activeTab: item.tabId });
                            }
                        }}
                    >
                        <NavItem key={index}>
                            <span className={'tab-label'}>
                                <i className={cns('icon', 'fal fa-fw', item.icon)} />
                                {item.name}
                            </span>
                        </NavItem>
                    </NavLink>
                );
            }
            return null;
        });
        return (
            <Navbar className={cns('container', 'menuTabListControl', className)}>
                <Nav className={'menuTabList'}>{menu}</Nav>
            </Navbar>
        );
    }
}

export default MenuTabs;
